var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    fill: "white",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m607.6 84-61.602-61.602c-25.199-25.199-67.199-25.199-92.398 0l-336 333.2-44.801 201.6 201.6-44.801 333.2-333.2c25.199-25.199 25.199-67.199 0-95.199zm-361.2 378-100.8 22.398 22.398-100.8 249.2-249.2 78.398 78.398zm322-322-33.602 33.602-78.398-78.398 33.602-33.602c5.6016-5.6016 8.3984-5.6016 14 0l61.602 61.602c5.5977 5.5977 5.5977 11.195 2.7969 16.797z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilWhite);
export default __webpack_public_path__ + "static/media/edit-pencil-white.a34854dbdf65b0ce3391af3f0b7d59ce.svg";
export { ForwardRef as ReactComponent };